import React from "react";
import { useAuth } from "../../../hooks/pages/useAuth";
import { getPropertyStatus } from "../../../utils/admin/propertyValidation";

const PropertyTable = ({ properties, onEdit, onDelete }) => {
    const { user: currentUser } = useAuth();

    return (
        <div className="mt-4">
            {/* ========== BẢNG CHO MÀN HÌNH LỚN ========== */}
            <div className="hidden lg:block overflow-x-auto">
                <table className="w-full table-auto border border-gray-300 dark:border-gray-700 text-sm">
                    <thead className="bg-gray-100 dark:bg-gray-800">
                        <tr className="text-gray-900 dark:text-gray-100">
                            <th className="border p-2">ID</th>
                            <th className="border p-2">Tiêu đề</th>
                            <th className="border p-2">Dự án</th>
                            <th className="border p-2">Nhà phát triển</th>
                            <th className="border p-2">Loại giao dịch</th>
                            <th className="border p-2">Loại hình</th>
                            <th className="border p-2">Phòng ngủ</th>
                            <th className="border p-2">Phòng tắm</th>
                            <th className="border p-2">Diện tích (m²)</th>
                            <th className="border p-2">Giá (VNĐ)</th>
                            <th className="border p-2">Trạng thái duyệt</th>
                            <th className="border p-2">Bán</th>
                            <th className="border p-2">Hành động</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
                        {properties.length > 0 ? (
                            properties.map((item) => {
                                const statusInfo = getPropertyStatus(item.status);

                                return (
                                    <tr
                                        key={item.id}
                                        className="hover:bg-gray-50 dark:hover:bg-gray-800"
                                    >
                                        <td className="border p-2">
                                            {item.id}
                                        </td>

                                        <td className="border p-2 max-w-[200px] truncate">
                                            {item.title}
                                        </td>

                                        <td className="border p-2">
                                            {item.projectName || "-"}
                                        </td>

                                        <td className="border p-2">
                                            {item.developer || "-"}
                                        </td>

                                        <td className="border p-2 capitalize">
                                            {item.transactionType}
                                        </td>

                                        <td className="border p-2 capitalize">
                                            {item.propertyType}
                                        </td>

                                        <td className="border p-2 text-center">
                                            {item.bedrooms || 0}
                                        </td>

                                        <td className="border p-2 text-center">
                                            {item.bathrooms || 0}
                                        </td>

                                        <td className="border p-2 text-right">
                                            {item.area?.toLocaleString() || "-"}
                                        </td>

                                        <td className="border p-2 text-right font-semibold text-green-600 dark:text-green-400">
                                            {item.price?.toLocaleString()} đ
                                        </td>

                                        <td className="border p-2">
                                            <span className={statusInfo.className}>
                                                {statusInfo.label}
                                            </span>
                                        </td>

                                        <td className="border p-2">
                                            {item.isSold
                                                ? "Đã bán"
                                                : "Còn bán"}
                                        </td>

                                        <td className="border p-2 space-x-2 text-center">
                                            {currentUser?.role ===
                                                "admin" && (
                                                    <>
                                                        <button
                                                            onClick={() =>
                                                                onEdit(item)
                                                            }
                                                            className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded"
                                                        >
                                                            Sửa
                                                        </button>

                                                        <button
                                                            onClick={() =>
                                                                onDelete(item.id)
                                                            }
                                                            className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded"
                                                        >
                                                            Xóa
                                                        </button>
                                                    </>
                                                )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan="13"
                                    className="text-center py-4 text-gray-500"
                                >
                                    Không có dữ liệu
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* ========== CARD VIEW CHO MÀN HÌNH NHỎ ========== */}
            <div className="lg:hidden space-y-4">
                {properties.map((item) => (
                    <div
                        key={item.id}
                        className="border rounded p-4 bg-white dark:bg-gray-900 shadow-sm text-sm text-gray-900 dark:text-gray-100"
                    >
                        <div><strong>Tiêu đề:</strong> {item.title}</div>
                        <div><strong>Dự án:</strong> {item.projectName || "-"}</div>
                        <div><strong>Nhà phát triển:</strong> {item.developer || "-"}</div>
                        <div><strong>Loại giao dịch:</strong> {item.transactionType}</div>
                        <div><strong>Loại hình:</strong> {item.propertyType}</div>
                        <div><strong>Diện tích:</strong> {item.area} m²</div>
                        <div><strong>Giá:</strong> {item.price?.toLocaleString()} đ</div>
                        <div><strong>Trạng thái:</strong> {item.status}</div>
                        <div><strong>Bán:</strong> {item.isSold ? "Đã bán" : "Còn bán"}</div>

                        {currentUser?.role === "admin" && (
                            <div className="mt-2 space-x-2">
                                <button
                                    onClick={() => onEdit(item)}
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                                >
                                    Sửa
                                </button>
                                <button
                                    onClick={() => onDelete(item.id)}
                                    className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                >
                                    Xoá
                                </button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PropertyTable;
